module.exports = __webpack_public_path__ + "static/cdLogo-0e180810c463457e8b6eeb52c0a885b8.svg";